import type { TMessages } from '@/types/TMessages'

export const messages = { header: 'Лучшие акционные предложения' } satisfies TMessages
